const Footer = () => (
  <footer>
    <div className="footer-content">
      <div className="footer-left">
        <h3>ggaarts</h3>
        <p>Artist: Preetham G Acharya, Barkur</p>
        <p>Developer: Preetham G Acharya</p>
        <p>Handcrafted Heritage Art from Karnataka</p>
      </div>

      <div className="footer-right">
        <a className="social-icon" style={{background:"#df00c1"}} href="https://instagram.com/gga_arts/#">IG</a>
        <a className="social-icon" style={{background:"#0047df"}} href="https://facebook.com/gga_arts/#">FB</a>
        <a className="social-icon" style={{background:"#df0000"}} href="https://www.youtube.com/@ggaarts2804/#">YT</a>
      </div>
    </div>

    <div className="footer-bottom">
      © {new Date().getFullYear()} ggaarts • All Rights Reserved
    </div>
  </footer>
);

export default Footer;
